module.exports = __webpack_public_path__ + "img/sweden-breast-cancer-female.57ac2fa3.png";